import { useEffect, useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap"
import { startFarmSeaFood } from "../../services/authService";
import { DANG_CAN_QUET, DONE_CAN_QUET } from "../../constants/errMessage";
import { SCREEN_SETTING } from "../../constants/screenRouter";
import { TOAST_TYPE, updateToastPromise } from "../../contexts/ToastProvider";
import { toast } from "react-toastify";
import { MAP_CONFIG_RESOURCE, PLAYER_CONFIG_IMAGE, PLAYER_CONFIG_SEAFOOD } from "../../constants/Common";
import MoleculeImageLable from "../../Molecule/MoleculeImageLable";
import usePlayerConfig from "../../hooks/usePlayerConfig";
import useSettingScreen from "../../hooks/useSettingScreen";
import usePlayerResourceTotal from "../../hooks/usePlayerResourceTotal";
import useOnlineInfo from "../../hooks/useOnlineInfo";
import usePlayerInfo from "../../hooks/usePlayerInfo";
const PlayerSeaFood = ({ playerId, isFarmingSeaFood }) => {
    const [canCanquet, setCanCanquet] = useState(false);
    const [idTimer, setIdTimer] = useState(null);
    const [toastPromiseId, setToastPromiseId] = useState(null);
    const { configs, updateSingleConfig } = usePlayerConfig(playerId)
    const { gotoScreen } = useSettingScreen(playerId);
    const { resourceTotal } = usePlayerResourceTotal(playerId);
    const { online } = useOnlineInfo(playerId);
    const { playerInfo } = usePlayerInfo(playerId);

    const handleCanquet = () => {
        setCanCanquet(false);
        startFarmSeaFood(playerInfo.Id, playerInfo.Name).then((res) => {
            //console.log('handleCanquet', res.error)
            if (res.error === false) {
                setCanCanquet(true);
            }
        }).catch((error) => {
            setCanCanquet(true)
        });
    }

    useEffect(() => {
        if (online == false || isFarmingSeaFood == true) {
            clearTimeout(idTimer);
            setCanCanquet(false);
        }
        else if (online == true && !isFarmingSeaFood && canCanquet == false) {
            const idTimeout = setTimeout(() => {
                setCanCanquet(online && !isFarmingSeaFood);
            }, 2000);
            setIdTimer(idTimeout);
        }
        if (!isFarmingSeaFood && toastPromiseId) {
            updateToastPromise(toastPromiseId, DONE_CAN_QUET, TOAST_TYPE.SUCCESS);
        }
        if (isFarmingSeaFood) {
            const toastId = toast.loading(DANG_CAN_QUET);
            setToastPromiseId(toastId);
        }
        return () => {
            setCanCanquet(false);
            updateToastPromise(toastPromiseId, '', TOAST_TYPE.DEFAULT);
        }
    }, [online, isFarmingSeaFood])

    return (
        <Row className="mt-3 border-bottom" >
            <Col>
                <Row xs={2} sm={3} md={4} lg={6}>
                    {PLAYER_CONFIG_SEAFOOD.map((configId) => (
                        <MoleculeImageLable key={`MoleculeImageLable-${configId}`} img={PLAYER_CONFIG_IMAGE[configId]}
                            text={`${resourceTotal[MAP_CONFIG_RESOURCE[configId]]}/${configs[configId]}`}
                        />
                    ))}
                </Row>
            </Col>
            <Col xs={3} sm={2} md={2} lg={2} className="d-flex align-items-center justify-content-center ">
                <Row xs={1} sm={1} md={1} lg={2} className="d-flex text-nowrap">
                    <div className="mt-3 mt-lg-0">
                        <Button className="" variant="success" disabled={!canCanquet} onClick={handleCanquet}>Càn Quét</Button>
                    </div>
                </Row>
            </Col>
        </Row>
    );
}

export default PlayerSeaFood